<template>
    <v-container>
        <h1 class="titulo mb-4">BLOQUEIO DE PESSOAS</h1>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="6" md="3">
                        <h4 class="mb-1" style="color: black; font-weight: bold;">Bloqueio de Cliente Principal:</h4>
                        <v-switch v-model="bloqueio_pessoas" :label="`Habilitar/Desabilitar`"></v-switch>
                    </v-col>
                    <v-col cols="6" md="3">
                        <h4 class="mb-1" style="color: black; font-weight: bold;">Bloqueio de Cônjuge/Sócios:</h4>
                        <v-switch v-model="bloqueio_conjuge_socios" :label="`Habilitar/Desabilitar`"></v-switch>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end">
                        <HintMessage style="max-width: 500px;" class="mb-5" title="DICA PARA CONFIGURAÇÃO"
                                     icon="mdi-lightbulb-on-outline" icon-color="secondary"
                                     description="<p><strong>Toggle de Bloqueio para Cônjuges e Sócios:</strong> Se o sócio ou o cônjuge do cliente <strong>conter bloqueio</strong>, o cliente principal será <strong>impedido de realizar a compra</strong>.</p>
                                     <p><strong>Toggle de Bloqueio de Clientes Principais:</strong> Habilita/Desabilita a funcionalidade de <strong>bloqueio para todos os clientes principais</strong>.</p>"
                                     :description-html="true" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="d-flex justify-end">
                        <v-btn class="transition ml-2" color="primary" rounded @click="salvarBloqueio">
                            Salvar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { AlertTypes } from '@/plugins/alerts_types'
  import { notification } from '@/plugins/helpers'

  export default {
    name: 'BloqueioPessoas',
    data: () => ({
      bloqueio_pessoas: false,
      bloqueio_conjuge_socios: false
    }),
    mounted () {
      this.getBloqueios()
    },
    methods: {
      async getBloqueios () {
        try {
          const response = await this.$http.get('/painel/bloqueio_pessoas/listar')
          const bloqueio = response.data
          this.bloqueio_pessoas = bloqueio.bloqueio_pessoas === 1 || bloqueio.bloqueio_pessoas === true
          this.bloqueio_conjuge_socios = bloqueio.bloqueio_conjuge_socios === 1 || bloqueio.bloqueio_conjuge_socios === true
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
          console.error('Erro ao buscar bloqueios:', error)
        }
      },

      async salvarBloqueio () {
        const payload = {
          bloqueio_pessoas: this.bloqueio_pessoas,
          bloqueio_conjuge_socios: this.bloqueio_conjuge_socios
        }
        try {
          const response = await this.$http.post('/painel/bloqueio_pessoas/salvar', payload)
          notification(AlertTypes.SUCCESS, response.data.mensagem)
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      }
    }
  }
</script>
